<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.9855 2.39382C19.8139 1.22224 17.9144 1.22224 16.7428 2.39382L15.2508 3.88581L15.0017 4.13398L2.24112 16.8447L1.94238 17.1423L1.9469 17.564L1.99995 22.5109L2.01045 23.4897L2.98922 23.5001L7.93641 23.5529L8.35804 23.5574L8.6556 23.2587L21.1205 10.7441L21.3652 10.4993L23.1068 8.75778C24.2784 7.5862 24.2784 5.68671 23.1068 4.51514L20.9855 2.39382ZM18.157 3.80803C18.5476 3.41751 19.1807 3.41751 19.5713 3.80803L21.6926 5.92935C22.0831 6.31987 22.0831 6.95304 21.6926 7.34356L20.6581 8.37801L17.1226 4.84247L18.157 3.80803ZM3.95131 17.9641L15.706 6.2553L19.2444 9.79363L7.53613 21.5486L3.98934 21.5107L3.95131 17.9641Z"
      fill="currentColor"
    />
  </svg>
</template>
